<template>
  <div class="container-box">
    <h2 class="title-type-1">
      캠페인 수정
      <span class="attention-coment-1">
        <v-icon>mdi-alert-circle</v-icon>
        캠페인 수정 후 저장버튼을 클릭하여야 변경 정보가 저장됩니다.
      </span>
    </h2>
    <ul class="tab-type-1">
      <li>
        <router-link :to="{ name: 'campaignModify' }">캠페인 정보</router-link>
      </li>
      <li>
        <a href="javascript:void(0);" class="active">캠페인 광고상품 관리</a>
      </li>
    </ul>
    <!-- list-contents -->
    <div class="list-contents">
      <ListContents />
    </div>
    <!--// list-contents -->
  </div>
</template>

<script>
import ListContents from './listContents.vue';

export default {
  components: {
    ListContents,
  },
  data: () => ({}),
  computed: {},
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped></style>
